/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_confirm_dialog_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const zh_hans1_confirm_dialog_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认`)
};

const zh_hant1_confirm_dialog_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認`)
};

const fr_confirm_dialog_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer`)
};

const de_confirm_dialog_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen`)
};

const ja_confirm_dialog_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認`)
};

const ko_confirm_dialog_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확인`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const confirm_dialog_confirm = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.confirm_dialog_confirm(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("confirm_dialog_confirm", locale)
	if (locale === "en") return en_confirm_dialog_confirm(inputs)
	if (locale === "zh-Hans") return zh_hans1_confirm_dialog_confirm(inputs)
	if (locale === "zh-Hant") return zh_hant1_confirm_dialog_confirm(inputs)
	if (locale === "fr") return fr_confirm_dialog_confirm(inputs)
	if (locale === "de") return de_confirm_dialog_confirm(inputs)
	if (locale === "ja") return ja_confirm_dialog_confirm(inputs)
	return ko_confirm_dialog_confirm(inputs)
};